import { Heart, Mail } from 'lucide-react'
import { Button } from '@/components/ui/button'

const columns = [
  {
    title: 'Project',
    links: [
      { label: 'Download', href: '/#download' },
      { label: 'Features', href: '/#features' },
      { label: 'Supported Radios', href: '/#radios' },
      { label: 'Get Started', href: '/#get-started' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Documentation', href: '/docs' },
      { label: 'Beginners Guide', href: '/beginners-guide' },
      { label: 'Mobile Guide', href: '/beginners-guide#mobile' },
      { label: 'FAQ', href: '/faq' },
      { label: 'Report an Issue', href: '/support' },
    ],
  },
  {
    title: 'Community',
    links: [
      { label: 'Community', href: '/community' },
      { label: 'Forums', href: '/forum' },
      { label: 'Developers', href: '/developers' },
      { label: 'About', href: '/about' },
      { label: 'Contact Rick', href: 'mailto:rick@newchirp.net' },
    ],
  },
]

export function SiteFooter() {
  return (
    <footer className="bg-background">
      <div className="mx-auto max-w-7xl px-4 py-16">
        <div className="grid gap-10 md:grid-cols-[1.5fr_repeat(3,1fr)]">
          <div>
            <a href="/" className="flex items-center gap-2">
              <img
                src="/newchirp-logo.svg"
                alt="NewChirp logo"
                className="h-9 w-9 rounded-lg"
                width={36}
                height={36}
              />
              <span className="font-mono text-lg font-bold tracking-tight">
                New<span className="text-primary">Chirp</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-muted-foreground">
              A modern reimagining of the classic CHIRP programming software. Free, open-source, and
              cross-platform — built for ham and GMRS communities.
            </p>
            <a
              href="mailto:rick@newchirp.net"
              className="mt-4 inline-flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              <Mail className="h-4 w-4 text-primary" />
              rick@newchirp.net
            </a>
            <Button
              className="mt-5"
              variant="outline"
              nativeButton={false}
              render={<a href="/donate" aria-label="Donate to the NewChirp project" />}
            >
              <Heart className="h-4 w-4 fill-red-500 text-red-500" />
              Donate to NewChirp
            </Button>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="font-mono text-sm font-semibold text-foreground">{column.title}</h3>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target={link.href.startsWith('http') ? '_blank' : undefined}
                      rel={link.href.startsWith('http') ? 'noreferrer' : undefined}
                      className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-border/60 pt-8 text-sm text-muted-foreground sm:flex-row">
          <p>
            NewChirp — led by Rick Lopez. A modern reimagining of CHIRP, licensed under the GPL.
          </p>
          <div className="flex items-center gap-4">
            <a href="/privacy" className="transition-colors hover:text-foreground">
              Privacy policy
            </a>
            <p className="flex items-center gap-1.5">
              Made with <Heart className="h-3.5 w-3.5 text-primary" /> for amateur radio and GMRS
              operators
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
